var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationDot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 12.2188C3.21875 10.6953 0.5 7.0625 0.5 5C0.5 2.51562 2.49219 0.5 5 0.5C7.48438 0.5 9.5 2.51562 9.5 5C9.5 7.0625 6.75781 10.6953 5.53906 12.2188C5.25781 12.5703 4.71875 12.5703 4.4375 12.2188ZM5 6.5C5.82031 6.5 6.5 5.84375 6.5 5C6.5 4.17969 5.82031 3.5 5 3.5C4.15625 3.5 3.5 4.17969 3.5 5C3.5 5.84375 4.15625 6.5 5 6.5Z",
    fill: "#47474A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDot);
export default __webpack_public_path__ + "static/media/location-dot.eff43f11c03a5912f7e6f18e06c85e31.svg";
export { ForwardRef as ReactComponent };